import React from "react";
import { AlertTriangle, Inbox, Loader2, Search } from "lucide-react";

/**
 * Shared loading / empty / error / idle state blocks so every SEPA list (the
 * transaction tables and the spotlight search) presents the same states in the
 * same way. Each block renders only the inner content; the caller wraps it in a
 * table cell (`colSpan`) or a plain container as appropriate.
 */

const wrap = "flex flex-col items-center justify-center gap-2 px-4 py-10 text-center";

export const SepaLoadingBlock: React.FC<{ message?: string }> = ({ message = "Wird geladen…" }) => (
  <div className={`${wrap} text-slate-400`}>
    <Loader2 className="h-5 w-5 animate-spin" />
    <span className="text-sm">{message}</span>
  </div>
);

export const SepaEmptyBlock: React.FC<{ message: string }> = ({ message }) => (
  <div className={`${wrap} text-slate-400`}>
    <Inbox className="h-6 w-6" />
    <span className="text-sm">{message}</span>
  </div>
);

export const SepaIdleBlock: React.FC<{ message: string }> = ({ message }) => (
  <div className={`${wrap} text-slate-400`}>
    <Search className="h-6 w-6" />
    <span className="text-sm">{message}</span>
  </div>
);

/**
 * Error state — shows the actual backend message so the user understands what
 * went wrong (business rule, validation, or a generic fallback).
 */
export const SepaErrorBlock: React.FC<{ message: string }> = ({ message }) => (
  <div className={`${wrap} text-rose-600`}>
    <AlertTriangle className="h-6 w-6" />
    <span className="max-w-md text-sm font-medium">{message}</span>
  </div>
);
